import { ProCard, ProForm, ProFormText } from "@ant-design/pro-components";
import { Button, notification, Space } from "antd";
import React from "react";
import { postRequest } from "../../services/EndPointApiService";
import ApplicationStore from "../../store/ApplicationStore";
import { Container } from "reactstrap";

const Process = () => {
  const userAuth = ApplicationStore((state) => state.userAuth);
  return (
    <Container>
      <ProCard
        style={{ width: "65vw", minWidth: "250px" }}
        bordered
        title={
          <Space>
            <i className="icofont-license icofont-2x"></i>
            <h3>Process current transaction</h3>
          </Space>
        }
      >
        <Space style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="primary"
            danger
            onClick={async () => {
              if (window.confirm("Update Facebook Blacklist ? ")) {
                await postRequest("DataList/OpenBlacklist");
                notification.success({
                  message: "Blacklist Updated",
                  description:
                    "Blacklist Updated to newly joined successfully.",
                });
              }
            }}
          >
            Update Current Blacklist to New Joiner
          </Button>
        </Space>
        <br />
        <ProForm
          title="Process Current transaction"
          onFinish={async (values) => {
            if (userAuth.allowProcess)
              return postRequest("process/transaction", values);
            else {
              notification.error({
                message: "Process Trnsaction",
                description:
                  "You dont have permission to do this. Please contact your administrator.",
              });
            }
          }}
        >
          <ProFormText
            fieldProps={{
              size: "large",
            }}
            label="Transaction Name"
            name={"transactionType"}
            rules={[{ required: true }]}
          />
        </ProForm>
      </ProCard>
    </Container>
  );
};

export default Process;
